import React from 'react'

function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="site__footer">
      <small>Designed and built by Esther Atebije</small>
      <small>&copy; {currentYear}</small>
    </footer>
  )
}

export default Footer
